<div class="json-viewer">
  @for (item of items; track item.key) {
    <div class="item">
      <div class="rep-obj" (click)="toggle(item)">
        @if (item.isExpandable) {
          <div class="toggler" [ngClass]="{'opened': item.isOpened}">
            <i class="material-icons">keyboard_arrow_right</i>
          </div>
        }
        <div class="rep-obj__row">
          <span class="item-key">{{item.key}}:</span>
          <span [ngClass]="item.valueClasses">{{item.title}}</span>
        </div>
      </div>
      @if (item.isExpandable && item.isOpened) {
        <div class="sub-child">
          <app-jsonviewer [json]="item.value"></app-jsonviewer>
        </div>
      }
    </div>
  }
</div>
